function addToCart(type, id) {
    $.ajax({
        url: 'shopping/add-cart',
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        },
        method: 'POST',
        data: {
            type: type,
            product: id
        },
        success: function (response) {
            checkoutData(response['carts'], response['menu_items'], response['total_price']);

        },
        error: function (err) {
            const errMessages = JSON.parse(err.responseText)
            const lang = $('meta[name="locale"]').attr('content')

            let errMessage = errMessages['err'][lang]['msg']
            let status = errMessages['err'][lang]['status']

            Swal.fire({
                title: status,
                text: errMessage,
                icon: "warning"
            });
        }
    })
}

function getCarts() {
    $.ajax({
        url: 'shopping/carts',
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        },
        method: 'POST',
        success: function (response) {
            checkoutData(response['carts'], response['menu_items'], response['total_price']);
        },
        error: function (err) {

        }
    })
}

function checkoutData(data, menu_items, total_price) {
    const baseUrl = $('meta[name="base_url"]').attr('content')
    const wrapAdditionalProduct = $('#wrap-additional-product')
    const wrapPackageProduct = $('#wrap-package-product');

    if (data && 'package' in data) {
        const package = data['package']
        
        if (package) {
            const urlPackage = baseUrl + '/upload/package/featured_img/'
            wrapPackageProduct.html(cardProduct(menu_items, package, urlPackage + package['featured_img'], 0))
        }
    }

    if (data && 'additional' in data) {
        const additionals = data['additional']
        
        
        if (additionals) {
            const urlAdditional = baseUrl + '/upload/additional/featured_img/'
            let additionalContent = '';
            additionals.forEach((element, key) => {
                additionalContent += cardProduct(menu_items, element, urlAdditional + element['featured_img'], key)
            });
            wrapAdditionalProduct.html(additionalContent)
        }
    }else {
        wrapAdditionalProduct.html('')
    }

    const tempTotalPrice = $('#temp-total-price')
    tempTotalPrice.html(format_rupiah(total_price))

    setTimeout(() => {
        $('.placeholder').removeClass('placeholder');
    }, 2000);
}

function cardProduct(menu_items, data, img, key) {
    let type = data['type']
    var html = '<div class="card mb-3" aria-hidden="true">' +
        '<div class="row p-0 m-0">' +
        '<div class="col-md-4 p-0">' +
        '<img src="' + img + '" class="card-img-top object-fit-cover w-100 h-100 placeholder" alt="...">' +
        '</div>' +
        '<div class="col-md-8">' +
        '<div class="card-body">' +
        '<h5 class="card-title placeholder-glow">' +
        '<span class="placeholder col-12 h6 py-2">' + transString(data['name']) + '</span>' +
        '</h5>'

    if (type == 'package') {
        html += '<select class="mb-2 placeholder form-control" data-method="portion" data-type="' + type + '" onchange="actionCart(this, ' + key + ')">';
        menu_items.forEach(element => {
            html += '<option value="' + element['id'] + '" ' + (element['id'] == data["portion"] ? 'selected' : '') + '>' + transString(element['name']) + '</option>';
        });
        html += '</select>';
    }

    if (type == 'additional') {
        html += '<p class="card-text placeholder-glow">' +
            '<span class="placeholder col-12">Qty: ' + parseInt(data["qty"]) + '</span>' +
            '</p>' +
            '<button class="btn btn-primary me-2" data-method="min" data-type="' + type + '" onclick="actionCart(this,' + key + ')">-</button>' +
            '<button class="btn btn-primary" data-method="plus" data-type="' + type + '" onclick="actionCart(this,' + key + ')">+</button>'
    }

    html += '</div>' +
        '</div>' +
        '</div>' +
        '</div>'

    return html;
}

function actionCart(event, key) {
    let method = event.dataset.method
    let type = event.dataset.type
    let value = 0

    if (method == "portion") {
        value = event.value
    }

    $.ajax({
        url: 'shopping/action-cart',
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        },
        method: 'POST',
        data: {
            method: method,
            type: type,
            key: key,
            value: value
        },
        success: function (response) {
            checkoutData(response['carts'], response['menu_items'], response['total_price']);
        },
        error: function (err) {

        }
    })
}

function format_rupiah(amount) {
    return amount.toFixed(0).replace(/\d(?=(\d{3})+$)/g, '$&.');
}

function getDateTomorrow() {
    // Get the current date
    var today = new Date();

    // Calculate tomorrow's date
    var tomorrow = new Date(today);
    tomorrow.setDate(today.getDate() + 1);

    // Format the date in the "YYYY-MM-DD" format
    var formattedTomorrow = tomorrow.toISOString().split('T')[0];

    // Set the minimum date for the input field
    const startDate = document.getElementById('start_date')

    if (startDate) {
        startDate.min = formattedTomorrow;
    }
}

function changeEndServiceDate() {
    const startDate = document.getElementById('start_date');

    if (startDate) {
        const endDate = document.getElementById('end_date');
        const totalDay = startDate.dataset.tday;

        startDate.onchange = () => {
            const selectedDate = new Date(startDate.value);
            selectedDate.setDate(selectedDate.getDate() + parseInt(totalDay));

            // Format the date in the "YYYY-MM-DD" format
            const formattedEndDate = selectedDate.toISOString().split('T')[0];

            endDate.value = formattedEndDate;
        };
    }
}

$(document).ready(function () {
    const shopping = document.getElementById('shopping')
    if (shopping) {
        getCarts();
    }

    const checkout = document.getElementById('checkout')
    if (checkout) {
        getDateTomorrow();
        changeEndServiceDate();
    }
});
